import BoardQNA from '../BoardQNA';

const BoardQNAContainer = () => {
  return <BoardQNA />;
};

export default BoardQNAContainer;
